/**
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Kit 2 PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Kit 2 PRO React using thie file.
 */

export default {
  background: {
    default: "#f1f5f9",  // slate-100 - consistent light background
  },

  text: {
    main: "#7b809a",
    focus: "#7b809a",
  },

  transparent: {
    main: "rgba(0, 0, 0, 0)",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#1e3a8a", // indigo-900 - brand primary
    focus: "#1e40af", // indigo-800 - hover states
  },

  secondary: {
    main: "#0f172a",    // slate-900 - brand secondary
    focus: "#1e293b",   // slate-800 - focus states
  },

  info: {
    main: "#0369a1",    // Professional sky blue
    focus: "#0284c7",   // Brighter blue for focus
  },

  success: {
    main: "#059669",    // Professional emerald green
    focus: "#10b981",   // Brighter emerald for focus
  },

  warning: {
    main: "#d97706",    // Professional amber - accent color
    focus: "#f59e0b",   // Brighter amber for focus
  },

  error: {
    main: "#dc2626",    // Professional red - clean and modern
    focus: "#ef4444",   // Brighter red for focus
  },

  light: {
    main: "#f1f5f9",  // slate-100
    focus: "#e2e8f0",  // slate-200
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f1f5f9",    // slate-100 - very light background
    200: "#e2e8f0",    // slate-200 - light background
    300: "#cbd5e1",    // slate-300 - borders
    400: "#94a3b8",    // slate-400 - disabled
    500: "#64748b",    // slate-500 - placeholder
    600: "#475569",    // slate-600 - secondary text
    700: "#334155",    // slate-700 - body text
    800: "#1e293b",    // slate-800 - headings
    900: "#0f172a",    // slate-900 - dark text/backgrounds
  },

  gradients: {
    primary: {
      main: "#1e3a8a",      // indigo-900 - brand gradient start
      state: "#0f172a",     // slate-900 - brand gradient end
    },

    secondary: {
      main: "#0f172a",      // slate-900 gradient
      state: "#334155",     // slate-700 gradient
    },

    info: {
      main: "#0369a1",      // Professional sky blue gradient
      state: "#0284c7",
    },

    success: {
      main: "#059669",      // Professional emerald gradient
      state: "#10b981",
    },

    warning: {
      main: "#d97706",      // Professional amber gradient
      state: "#f59e0b",
    },

    error: {
      main: "#dc2626",      // Professional red gradient
      state: "#ef4444",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#1e3a8a",
    secondary: "#475569",
    info: "#0369a1",
    success: "#059669",
    warning: "#d97706",
    error: "#dc2626",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
